export enum UserSettingsTooltip {
  ResultsInsights = `If enabled, the results of the PSS\u00AEE execution (locally) will be provided to the AI model as input for further analysis`,
  AutoCodeCorrection = `If enabled, AI generated code will be executed (locally) in a sandbox to correct code errors`
}
